import { useMemo } from "react"
import { DefaultColumn } from "@common/table/column.util"
import { DefaultFilterFns } from "@common/table/filterFns"
import { TableOptions } from "@common/table/types"
import { tableBaseThemes } from "@common/table/table.styles"


export const useTableOptions = ({
  aggregationFns,
  autoResetExpanded = false,
  columnResizeMode = "onChange",
  defaultColumn,
  enableColumnActions = false,
  enableColumnFilters = false,
  enableColumnOrdering = false,
  enableColumnResizing = false,
  enableExpandAll = true,
  enableExpanding,
  enableRowActions,
  enableFilters = true,
  enableGrouping = false,
  enableColumnVisibility = false,
  enableMultiRowSelection = true,
  enableMultiSort = true,
  enablePagination = false,
  enablePinning = false,
  enableRowSelection = false,
  enableSubRowSelection = false,
  enableSelectAll = true,
  enableSorting = true,
  enableTopToolbar = true,
  filterFromLeafRows = true,
  filterFns,
  manualFiltering,
  manualGrouping,
  manualPagination,
  manualSorting,
  sortingFns,
  themes = tableBaseThemes,
  ...rest
}: Partial<TableOptions>): TableOptions => {
  // const _aggregationFns = useMemo(
  //   () => ({ ...AggregationFns, ...aggregationFns }),
  //   [aggregationFns],
  // );

  const _filterFns = useMemo(() => ({ ...DefaultFilterFns, ...filterFns, }), [filterFns])
  const _sortingFns = useMemo(() => ({ ...sortingFns }), [sortingFns])
  const _defaultColumn = useMemo(
    () => ({ ...DefaultColumn, ...defaultColumn }),
    [defaultColumn]
  )
  // const _defaultDisplayColumn = useMemo(
  //   () => ({
  //     ...DefaultDisplayColumn,
  //     ...defaultDisplayColumn,
  //   }),
  //   [defaultDisplayColumn],
  // );

  // if (rest.enableRowVirtualization || rest.enableColumnVirtualization) {
  //   layoutMode = 'grid';
  // }

  // if (rest.enableRowVirtualization) {
  //   enableStickyHeader = true;
  // }

  if (enablePagination === false && manualPagination === undefined) {
    manualPagination = true
  }

  if (!rest.data?.length) {
    manualFiltering = true
    manualGrouping = true
    manualPagination = true
    manualSorting = true
  }

  return {
    autoResetExpanded,
    columnResizeMode,
    defaultColumn: _defaultColumn,
    enableColumnActions,
    enableColumnFilters,
    enableColumnOrdering,
    enableColumnResizing,
    enableExpandAll,
    enableExpanding,
    enableRowActions,
    enableFilters,
    enableGrouping,
    enableColumnVisibility,
    enableRowSelection,
    enableMultiRowSelection,
    enableSubRowSelection,
    enableMultiSort,
    enablePagination,
    enablePinning,
    enableSelectAll,
    enableSorting,
    enableTopToolbar,
    filterFromLeafRows,
    filterFns: _filterFns,
    manualFiltering,
    manualGrouping,
    manualPagination,
    manualSorting,
    sortingFns: _sortingFns,
    themes,
    ...rest,
  }
}
